<template>
  <AppSidebar
    v-model="navigationDrawerArchives"
    :mini="mini"
  >
    <div class="app-sidebar-menu">
      <AppSidebarItem
        v-for="item in sidebarItems"
        :key="item.key"
        :item="item"
        :icon-only="mini"
        @select="goTo"
      />
    </div>
  </AppSidebar>
</template>

<script>
import { mapState } from 'vuex'

import AppSidebar from '@/common/app-sidebar/AppSidebar.vue'
import AppSidebarItem from '@/common/app-sidebar/AppSidebarItem.vue'
import {
  ARCHIVES_ADD_ROUTE_NAME,
  ARCHIVES_ROUTE_NAME,
} from '@/router'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

export default {
  name: 'ArchivesSidebar',
  components: { AppSidebar, AppSidebarItem },
  computed: {
    ...mapState('global', ['mini']),
    sidebarItems () {
      return [
        {
          key: ARCHIVES_ROUTE_NAME,
          label: this.$t('archives.views.Archives.sideBar').toString(),
          icon: 'box-archive',
          kind: 'nav',
          active: [ARCHIVES_ROUTE_NAME, ARCHIVES_ADD_ROUTE_NAME].includes(this.$route.name),
          dataLocator: 'archives-nav-item',
        },
      ]
    },
    navigationDrawerArchives: {
      get () {
        return !this.$vuetify.display.mobile
          ? true
          : this.$store.state.global.navigationDrawerProfile
      },
      set (newValue) {
        if (!this.$vuetify.display.mobile) return
        this.$store.commit(`global/${GlobalMutationTypes.SET_NAVIGATION_DRAWER_PROFILE}`, newValue)
      },
    },
  },
  methods: {
    goTo (routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName }).catch(() => {})
      }
      this.navigationDrawerArchives = false
    },
  },
}
</script>
